/*
 * Customaly section behaviors. Original work.
 * Process showcase (tabs + auto-rotation), memory studio scroll motion,
 * and scroll-triggered centering.
 */
(function () {
  /* Process showcase ------------------------------------------------------ */

  function selectProcessStep(showcase, button) {
    var target = button.getAttribute('data-cu-process-step')

    showcase.querySelectorAll('[data-cu-process-step]').forEach(function (stepButton) {
      var isActive = stepButton === button

      stepButton.classList.toggle('is-active', isActive)
      stepButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
      stepButton.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    showcase.querySelectorAll('[data-cu-process-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-cu-process-panel') === target

      panel.hidden = !isActive
      panel.classList.toggle('is-active', isActive)
    })

    showcase.dispatchEvent(new CustomEvent('cu:process:change'))
  }

  function initializeProcessAutoRotation(showcase) {
    var buttons = Array.prototype.slice.call(showcase.querySelectorAll('[data-cu-process-step]'))
    var autoRotate = showcase.getAttribute('data-cu-process-auto') === 'true'
    var interval = parseInt(showcase.getAttribute('data-cu-process-interval'), 10) || 5000
    var timer = null
    var isFocusPaused = false
    var isInView = typeof window.IntersectionObserver === 'undefined'

    if (
      !autoRotate ||
      buttons.length < 2 ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return
    }

    function clearRotation() {
      if (timer) {
        window.clearTimeout(timer)
        timer = null
      }
    }

    function scheduleRotation() {
      clearRotation()

      if (!showcase.isConnected || document.hidden || !isInView || isFocusPaused) {
        return
      }

      timer = window.setTimeout(function () {
        var activeIndex = buttons.findIndex(function (button) {
          return button.getAttribute('aria-selected') === 'true'
        })

        selectProcessStep(showcase, buttons[(activeIndex + 1) % buttons.length])
      }, interval)
    }

    showcase.addEventListener('cu:process:change', scheduleRotation)
    showcase.addEventListener('focusin', function () {
      isFocusPaused = true
      clearRotation()
    })
    showcase.addEventListener('focusout', function (event) {
      if (event.relatedTarget && showcase.contains(event.relatedTarget)) {
        return
      }

      isFocusPaused = false
      scheduleRotation()
    })
    document.addEventListener('visibilitychange', scheduleRotation)

    if (typeof window.IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        isInView = entries[0].isIntersecting
        scheduleRotation()
      }, { threshold: 0.35 }).observe(showcase)
    } else {
      scheduleRotation()
    }
  }

  function initializeProcessShowcases(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-process]').forEach(function (showcase) {
      if (showcase.dataset.cuProcessReady === 'true') {
        return
      }

      showcase.dataset.cuProcessReady = 'true'

      showcase.querySelectorAll('[data-cu-process-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectProcessStep(showcase, button)
        })
      })

      showcase.querySelectorAll('[data-cu-process-next]').forEach(function (button) {
        button.addEventListener('click', function () {
          var nextStep = showcase.querySelector(
            '[data-cu-process-step="' + button.getAttribute('data-cu-process-next') + '"]'
          )

          if (nextStep) {
            selectProcessStep(showcase, nextStep)
          }
        })
      })

      initializeProcessAutoRotation(showcase)
    })
  }

  /* Memory studio --------------------------------------------------------- */

  function initializeMemoryStudios(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-memory-motion]').forEach(function (studio) {
      if (studio.dataset.cuMemoryMotionReady === 'true') {
        return
      }

      var track = studio.querySelector('[data-cu-memory-track]')
      var sticky = studio.querySelector('[data-cu-memory-sticky]')
      var surface = studio.querySelector('[data-cu-memory-surface]')
      var base = studio.querySelector('.cu-memory-studio__base')
      var copy = studio.querySelector('[data-cu-memory-copy]')
      var badge = studio.querySelector('[data-cu-memory-badge]')
      var fragments = Array.prototype.slice.call(studio.querySelectorAll('[data-cu-memory-fragment]'))

      if (!track || !sticky || !surface || !base || !copy) {
        return
      }

      studio.dataset.cuMemoryMotionReady = 'true'

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        studio.classList.add('is-memory-static')
        return
      }

      studio.classList.add('is-memory-motion-ready')

      var updateQueued = false
      var clamp = function (value, minimum, maximum) {
        return Math.min(maximum, Math.max(minimum, value))
      }
      var easeOutCubic = function (value) {
        return 1 - Math.pow(1 - value, 3)
      }

      var updateMotion = function () {
        var trackRect = track.getBoundingClientRect()
        var stickyTop = parseFloat(window.getComputedStyle(sticky).top) || 0
        var travel = Math.max(1, track.offsetHeight - sticky.offsetHeight)
        var progress = clamp((stickyTop - trackRect.top) / travel, 0, 1)
        var isDesktop = window.matchMedia('(min-width: 769px)').matches
        var startScale = isDesktop ? 1.44 : 1.2
        var surfaceScale = startScale - ((startScale - 1) * progress)
        var surfaceShift = (1 - progress) * (isDesktop ? 24 : 12)
        var copyProgress = easeOutCubic(clamp((progress - 0.2) / 0.5, 0, 1))
        var cardProgress = easeOutCubic(clamp((progress - 0.16) / 0.68, 0, 1))
        var cardFade = 1 - clamp((progress - 0.84) / 0.14, 0, 1)
        var mediaWidth = Math.max(1, surface.offsetWidth)
        var mediaHeight = Math.max(1, surface.offsetHeight)
        var vectors = isDesktop
          ? [
              { x: -0.88, y: -0.72, scale: 1.62, rotate: -8 },
              { x: 0.92, y: -0.62, scale: 1.5, rotate: 7 },
              { x: -0.95, y: 0.74, scale: 1.58, rotate: 6 },
              { x: 0.98, y: 0.7, scale: 1.72, rotate: -7 }
            ]
          : [
              { x: -0.62, y: -0.52, scale: 1.34, rotate: -6 },
              { x: 0.64, y: -0.48, scale: 1.3, rotate: 5 },
              { x: -0.68, y: 0.54, scale: 1.32, rotate: 5 },
              { x: 0.7, y: 0.5, scale: 1.36, rotate: -5 }
            ]

        surface.style.transform =
          'translate3d(0,' + surfaceShift.toFixed(2) + 'px,0) scale(' + surfaceScale.toFixed(4) + ')'
        base.style.opacity = (0.58 + (progress * 0.42)).toFixed(3)
        base.style.filter =
          'saturate(' + (0.76 + (progress * 0.24)).toFixed(3) + ') blur(' + ((1 - progress) * 1.8).toFixed(2) + 'px)'
        copy.style.opacity = (0.16 + (copyProgress * 0.84)).toFixed(3)
        copy.style.transform =
          'translate3d(0,' + ((1 - copyProgress) * 58).toFixed(2) + 'px,0) scale(' + (0.96 + (copyProgress * 0.04)).toFixed(4) + ')'

        if (badge) {
          var badgeProgress = easeOutCubic(clamp((progress - 0.62) / 0.25, 0, 1))
          badge.style.opacity = badgeProgress.toFixed(3)
          badge.style.transform = 'translate3d(0,' + ((1 - badgeProgress) * 24).toFixed(2) + 'px,0)'
        }

        fragments.forEach(function (fragment, index) {
          var vector = vectors[index] || vectors[0]
          var inverse = 1 - cardProgress

          fragment.style.opacity = (clamp(cardProgress * 2.4, 0, 1) * cardFade).toFixed(3)
          fragment.style.transform =
            'translate3d(' + (vector.x * mediaWidth * inverse).toFixed(2) + 'px,' +
            (vector.y * mediaHeight * inverse).toFixed(2) + 'px,0) ' +
            'scale(' + (1 + ((vector.scale - 1) * inverse)).toFixed(4) + ') ' +
            'rotate(' + (vector.rotate * inverse).toFixed(2) + 'deg)'
        })
      }

      var scheduleUpdate = function () {
        if (updateQueued) {
          return
        }

        updateQueued = true
        window.requestAnimationFrame(function () {
          updateQueued = false
          updateMotion()
        })
      }

      window.addEventListener('scroll', scheduleUpdate, { passive: true })
      window.addEventListener('resize', scheduleUpdate)
      updateMotion()
    })
  }

  /* Scroll-triggered centering -------------------------------------------- */

  function initializeScrollCenter(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-scroll-center]').forEach(function (element) {
      if (element.dataset.cuScrollCenterReady === 'true') {
        return
      }

      element.dataset.cuScrollCenterReady = 'true'

      if (
        typeof window.IntersectionObserver === 'undefined' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        element.classList.add('is-centered')
        return
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          return
        }

        element.classList.add('is-centered')
        observer.disconnect()
      }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' })

      observer.observe(element)
    })
  }

  /* Dropdowns (sorting, facets) ------------------------------------------- */
  /* The visible control is a <details> panel; the native <select> stays in the
     form so Dawn's facets.js keeps owning submission. */

  function initializeDropdowns(scope) {
    scope.querySelectorAll('[data-cu-dropdown]').forEach(function (dropdown) {
      if (dropdown.getAttribute('data-cu-dropdown-ready') === 'true') {
        return
      }

      dropdown.setAttribute('data-cu-dropdown-ready', 'true')

      var select = dropdown.querySelector('select')
      var details = dropdown.querySelector('details')
      var valueLabel = dropdown.querySelector('[data-cu-dropdown-value]')
      var options = Array.prototype.slice.call(dropdown.querySelectorAll('[data-cu-dropdown-option]'))

      if (!select || !details) {
        return
      }

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          select.value = option.getAttribute('data-value')

          if (valueLabel) {
            valueLabel.textContent = option.textContent.trim()
          }

          options.forEach(function (sibling) {
            var isSelected = sibling === option

            sibling.classList.toggle('is-selected', isSelected)
            sibling.setAttribute('aria-selected', isSelected ? 'true' : 'false')
          })

          details.removeAttribute('open')
          select.dispatchEvent(new Event('input', { bubbles: true }))
          select.dispatchEvent(new Event('change', { bubbles: true }))
        })
      })
    })
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-cu-dropdown] details[open]').forEach(function (details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open')
      }
    })
  })

  /* Collection toolbar popovers -------------------------------------------- */

  var GRID_COLUMNS_KEY = 'cu:grid-columns'

  function applyGridColumns(columns) {
    document.documentElement.style.setProperty('--cu-cols', columns)

    document.querySelectorAll('[data-cu-grid-column]').forEach(function (choice) {
      choice.classList.toggle('is-active', choice.getAttribute('data-cu-grid-column') === String(columns))
    })
  }

  function initializeCollectionTools(scope) {
    scope.querySelectorAll('[data-cu-facets-clear]').forEach(function (button) {
      button.addEventListener('click', function () {
        /* Forwards to Dawn's own reset link so the grid updates over AJAX. */
        var reset = document.querySelector('.active-facets-desktop .active-facets__button-remove')

        if (reset) {
          reset.click()
        }
      })
    })

    scope.querySelectorAll('[data-cu-facets-confirm]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('details')

        if (panel) {
          panel.removeAttribute('open')
        }
      })
    })

    scope.querySelectorAll('[data-cu-grid-column]').forEach(function (choice) {
      choice.addEventListener('click', function () {
        var columns = choice.getAttribute('data-cu-grid-column')

        applyGridColumns(columns)

        try {
          window.localStorage.setItem(GRID_COLUMNS_KEY, columns)
        } catch (error) {
          /* Private mode: the choice just does not persist. */
        }
      })
    })

    scope.querySelectorAll('[data-cu-view]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        /* The href alone would drop active filters and sorting. */
        event.preventDefault()

        var url = new URL(window.location.href)
        var view = link.getAttribute('data-cu-view')

        if (view) {
          url.searchParams.set('view', view)
        } else {
          url.searchParams.delete('view')
        }

        url.searchParams.delete('page')
        window.location.href = url.toString()
      })
    })

    if (scope.querySelector('[data-cu-grid-column]')) {
      var stored = null

      try {
        stored = window.localStorage.getItem(GRID_COLUMNS_KEY)
      } catch (error) {
        stored = null
      }

      if (stored) {
        applyGridColumns(stored)
      }
    }
  }

  /* Recently viewed -------------------------------------------------------- */

  var RECENTLY_VIEWED_KEY = 'cu:recently-viewed'

  function readRecentlyViewed() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(RECENTLY_VIEWED_KEY))

      return Array.isArray(stored) ? stored : []
    } catch (error) {
      return []
    }
  }

  function recordRecentlyViewed() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
    var id = meta && meta.product && meta.product.id

    if (!id) {
      return
    }

    var ids = readRecentlyViewed().filter(function (stored) {
      return String(stored) !== String(id)
    })

    ids.unshift(String(id))

    try {
      window.localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(ids.slice(0, 12)))
    } catch (error) {
      /* Private mode: nothing to persist. */
    }
  }

  function initializeRecentlyViewed(scope) {
    scope.querySelectorAll('[data-cu-recently-viewed]').forEach(function (container) {
      if (container.getAttribute('data-cu-recently-viewed-ready') === 'true') {
        return
      }

      container.setAttribute('data-cu-recently-viewed-ready', 'true')

      var max = parseInt(container.getAttribute('data-max-products'), 10) || 6
      var currentId = window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        String(window.ShopifyAnalytics.meta.product.id)

      var ids = readRecentlyViewed()
        .filter(function (id) {
          return id !== currentId
        })
        .slice(0, max)

      if (!ids.length) {
        return
      }

      var sectionId = container.closest('.shopify-section')
      var query = ids
        .map(function (id) {
          return 'id:' + id
        })
        .join(' OR ')

      var url =
        (window.routes && window.routes.search_url ? window.routes.search_url : '/search') +
        '?type=product&options[unavailable_products]=last&q=' +
        encodeURIComponent(query) +
        '&section_id=' +
        (sectionId ? sectionId.id.replace('shopify-section-', '') : '')

      fetch(url)
        .then(function (response) {
          return response.text()
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html')
          var source = parsed.querySelector('[data-cu-recently-viewed-grid]')
          var target = container.querySelector('[data-cu-recently-viewed-grid]')

          if (!source || !target || !source.children.length) {
            return
          }

          target.innerHTML = source.innerHTML
          container.removeAttribute('hidden')
        })
        .catch(function (error) {
          console.error(error)
        })
    })
  }

  /* Legal page table of contents ------------------------------------------ */

  /* Shopify renders /policies/* from its own template, which no theme file can
     override -- adopt the markup it emits so the policies get the same shell as
     the pages that do go through cu-legal.liquid. */
  function adoptPolicyMarkup(scope) {
    var policy = scope.querySelector('.shopify-policy__container')
    var body = policy && policy.querySelector('.shopify-policy__body')

    if (!policy || !body || policy.hasAttribute('data-cu-legal')) {
      return
    }

    var grid = document.createElement('div')
    var aside = document.createElement('aside')

    aside.className = 'cu-legal__aside'
    aside.hidden = true
    aside.setAttribute('data-cu-legal-aside', '')
    aside.innerHTML =
      '<p class="cu-legal__aside-title">On this page</p>' +
      '<nav class="cu-legal__toc" aria-label="On this page" data-cu-legal-toc></nav>'

    grid.className = 'cu-legal__grid'
    body.parentNode.insertBefore(grid, body)
    grid.appendChild(aside)
    grid.appendChild(body)

    body.classList.add('cu-legal__body')
    body.setAttribute('data-cu-legal-body', '')
    policy.classList.add('cu-legal')
    policy.setAttribute('data-cu-legal', '')
  }

  function initializeLegalToc(scope) {
    adoptPolicyMarkup(scope)

    scope.querySelectorAll('[data-cu-legal]').forEach(function (legal) {
      var body = legal.querySelector('[data-cu-legal-body]')
      var aside = legal.querySelector('[data-cu-legal-aside]')
      var toc = legal.querySelector('[data-cu-legal-toc]')

      if (!body || !aside || !toc || toc.children.length) {
        return
      }

      var headings = Array.prototype.slice.call(body.querySelectorAll('h2'))

      if (headings.length < 2) {
        return
      }

      headings.forEach(function (heading, index) {
        if (!heading.id) {
          heading.id = 'section-' + (index + 1)
        }

        var link = document.createElement('a')

        link.href = '#' + heading.id
        link.textContent = heading.textContent.trim()
        toc.appendChild(link)
      })

      aside.hidden = false
      legal.classList.add('cu-legal--with-toc')

      if (typeof window.IntersectionObserver === 'undefined') {
        return
      }

      var links = Array.prototype.slice.call(toc.children)
      var visible = []

      function highlight() {
        var current = visible.length ? visible[0] : null

        links.forEach(function (link) {
          if (current && link.getAttribute('href') === '#' + current) {
            link.setAttribute('aria-current', 'true')
          } else {
            link.removeAttribute('aria-current')
          }
        })
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var index = visible.indexOf(entry.target.id)

            if (entry.isIntersecting && index === -1) {
              visible.push(entry.target.id)
            } else if (!entry.isIntersecting && index !== -1) {
              visible.splice(index, 1)
            }
          })

          visible.sort(function (a, b) {
            return headings.indexOf(document.getElementById(a)) - headings.indexOf(document.getElementById(b))
          })

          highlight()
        },
        { rootMargin: '-100px 0px -70% 0px' }
      )

      headings.forEach(function (heading) {
        observer.observe(heading)
      })
    })
  }

  function initializeAll(scope) {
    initializeProcessShowcases(scope)
    initializeMemoryStudios(scope)
    initializeScrollCenter(scope)
    initializeDropdowns(scope)
    initializeCollectionTools(scope)
    initializeRecentlyViewed(scope)
    initializeLegalToc(scope)
  }

  document.addEventListener('DOMContentLoaded', function () {
    recordRecentlyViewed()
    initializeAll(document)
  })

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target)
  })
})()
